import { useEffect, useState } from "react";

import { Session, SessionTypesEnum } from "../../../../../../types/working-model";
import Icon, { ICONS } from "../../../../../general-ui/icon";
import NavigationDropdown from "../../../../../general-ui/dropdown/navigation-dropdown";

interface SelectCategoriesProps {
	sessions: Session[];
	onSelect?: (category: string) => void;
	sessionType?: SessionTypesEnum;
	resetCounter?: number;
}

export const ALL_CATEGORIES = 'ALL CATEGORIES';

const SelectCategories: React.FC<SelectCategoriesProps> = ({
	sessions,
	onSelect = () => null,
	sessionType,
	resetCounter,
}) => {
	const [selected, setSelected] = useState(ALL_CATEGORIES);

	// if resetCounter increments, then we reset the selected value:
	useEffect(() => {
		setSelected(ALL_CATEGORIES);
	}, [resetCounter]);

	const handleClick = (track: string) => () => {
		setSelected(track);
		onSelect(track);
	};

	const availableCategories = () => sessions.reduce((tracks: string[], session: Session) => {
		if (session.tracks?.length) {
			let allowBasedOnType = false;
			// if session is on demand, then only show languages from on demand sessions
			if (sessionType === SessionTypesEnum.onDemand && session.session_type === SessionTypesEnum.onDemand) {
				allowBasedOnType = true;
			}
			// if session is broadcast, then only show languages from broadcast sessions
			if (sessionType === SessionTypesEnum.broadcast && session.session_type === SessionTypesEnum.broadcast) {
				allowBasedOnType = true;
			}
			// if no sessionType passed in, then show all languages
			if (!sessionType) {
				allowBasedOnType = true;
			}
			const tracksSet = new Set(tracks);
			if (allowBasedOnType) {
				session.tracks.forEach((track: string) => tracksSet.add(track));
			}
			return Array.from(tracksSet);
		}
		return tracks;
	}, []);

	return (
		<div className="agenda-session-filter agenda-session-filter-categories">
			<NavigationDropdown
				title={selected}
				buttonClassName="agenda-sessions-actions-select"
				edge="center"
				renderCustomIcon={() => (
					<Icon name={ICONS.LITTLE_ARROW_DOWN} color="navdrop-arrow" size={11} />
				)}
			>
				<button className="sharp" onClick={handleClick(ALL_CATEGORIES)}>{ALL_CATEGORIES}</button>
				{availableCategories().map(track => (
					<button key={track} className="sharp" onClick={handleClick(track)}>
						{track}
					</button>
				))}
			</NavigationDropdown>
		</div>
	);
};

export default SelectCategories;
